import { Component, OnInit } from '@angular/core';
import { ServicerService } from '../../services/servicer.service';
import { IdentityService } from '../../../identity/services/identity.service';
import { GeneralService } from '../../../shared/services/general.service';
import { Advisor, IAdvisor } from '../../../shared/models/advisor.models'; // Define this model based on your backend response structure
import { DataGridColumn } from '../../../shared/models/DevExtreme/column.models'
import { AdvisoryRoles, SystemLoginType } from '../../../shared/enums/enum.enums';
import { IUser } from '../../../shared/models/identity.models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-advisor-list',
  templateUrl: './advisor-list.component.html',
  styleUrls: ['./advisor-list.component.css'],
})
export class AdvisorListComponent implements OnInit {
  private destroy$ = new Subject<void>();

  advisors: IAdvisor[] = [];
  user!: IUser;
  currentAdvisor: IAdvisor | null = null;
  isDisabled = true;

  gridColumns: Array<DataGridColumn> = [
    {
      dataField: 'fullName',
      caption: 'Name',
      //cellTemplate: 'colFullName',
      width: 140, // Keeping this fixed
      sortIndex: 0,
      sortOrder: 'asc',
    },
    {
      dataField: 'actions',
      caption: 'Actions',
      cellTemplate: 'btnActions',
      minWidth: 180, // Resizable
      flexGrow: 1,
      allowResizing: true,
    },
    { dataField: 'repNumber', caption: 'Rep Num.', minWidth: 180, flexGrow: 1, allowResizing: true },
    { dataField: 'tinForPublic', caption: 'TIN/SSN', width: 140, visible: false },
    { dataField: 'fullAddress', caption: 'Address', width: 200, visible: false },
    { dataField: 'systemLogin.username', caption: 'Username', minWidth: 180, flexGrow: 1, allowResizing: true },
    //{ dataField: 'systemLogin.role', caption: 'Role', visible: true, width: 110 },
    {
      dataField: 'systemLogin.loginStatusDesc',
      caption: 'Login stat.',
      visible: true,
      width: 80,
    },
    {
      dataField: 'systemLogin.lastLogin',
      caption: 'Last Login',
      dataType: 'datetime', // 'datetime' for hours/minutes
      format: 'MM/dd/yyyy hh:mm a', // DevExtreme will apply this in local time
      minWidth: 180, flexGrow: 2, allowResizing: true,
      calculateCellValue: (data: IAdvisor) =>
        data.systemLogin?.lastLogin ? new Date(data.systemLogin.lastLogin) : null,
    },
  ];
  constructor(
    private servicerService: ServicerService,
    private identityService: IdentityService,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.identityService.getUser().subscribe(
      (user) => {
        this.user = user;
        if (this.user.systemLoginType == SystemLoginType.ADVISOR) {
          this.currentAdvisor = this.user.advisor;
        }

        if (this.user.systemLoginType == SystemLoginType.SERVICER) {
          this.loadAllAdvisors();
        }
        //  else {
        //    this.loadAdvisors(this.currentAdvisor?.companyGroup.id || 0);
        //  }
      },
      (error) => this.generalService.showError(error)
    );
  }


  loadAdvisors(id: number): void {
    this.servicerService.getAdvisors(id).subscribe(
      (response) => {
        this.advisors = response;
      },
      (error) => this.generalService.showError(error)
    );
  }

  loadAllAdvisors(): void {
    this.servicerService.getAllAdvisors().subscribe(
      (response) => {
        this.advisors = response;
      },
      (error) => this.generalService.showError(error)
    );
  }

  enableSL(advisor: IAdvisor): void {
    this.servicerService.enableAdvisorSL(advisor).subscribe(
      (response) => {
        advisor.systemLogin = response.systemLogin;
        this.generalService.showSuccess(`Activation email sent to advisor at ${response.contactEmail}.`);
      },
      (error) => this.generalService.showError(error)
    );
  }

  reactivateSL(advisor: IAdvisor): void {
    this.servicerService.reactivateAdvisorSL(advisor).subscribe(
      (response) => {
        advisor.systemLogin = response.systemLogin;
        this.generalService.showSuccess(`Reactivation email sent to advisor at ${response.contactEmail}.`);
      },
      (error) => this.generalService.showError(error)
    );
  }

  disableSL(advisor: IAdvisor): void {
    this.servicerService.disableAdvisorSL(advisor).subscribe(
      (response) => {
        advisor.systemLogin = response.systemLogin;
        this.generalService.showSuccess('User system login canceled.');
      },
      (error) => this.generalService.showError(error)
    );
  }

  lockSL(advisor: IAdvisor): void {
    this.servicerService.lockAdvisorSL(advisor).subscribe(
      (response) => {
        advisor.systemLogin = response.systemLogin;
        this.generalService.showSuccess('User system login locked.');
      },
      (error) => this.generalService.showError(error)
    );
  }

  unlockSL(advisor: IAdvisor): void {
    this.servicerService.unlockAdvisorSL(advisor).subscribe(
      () => {
        if (advisor.systemLogin) {
          advisor.systemLogin.loginStatus = 1;
          advisor.systemLogin.loginStatusDesc = 'ACTIVE';
          this.generalService.showSuccess('User system login unlocked.');
        }
      },
      (error) => this.generalService.showError(error)
    );
  }

  impersonateAdvisor(advisor: IAdvisor, landingPage: string = '/advisor/dashboard'): void {
    if (this.okToImpersonateAdvisor(advisor)) {
      if (confirm(`Impersonate ${advisor.fullName}?`)) {
        if (advisor.systemLogin?.username) {
          this.identityService.impersonateUser(advisor.systemLogin.username)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (response) => {
                console.log('Impersonation response:', response);
                localStorage.clear();
                window.location.href = landingPage;              },
              error: (error) => {
                console.error('Error during impersonation:', error);
                this.generalService.showError(error);
              },
            });
        }
      }
    } else {
      this.generalService.showWarning('You can only impersonate users with ACTIVE Login Status.');
    }
  }

  okToImpersonateAdvisor(advisor: IAdvisor): boolean {
    return true;
    //return advisor.systemLogin?.loginStatus === 1 || false;
  }

  isServicerAdmin(): boolean {
    //    return (this.user.role == AdvisoryRoles.SERVICER_ADMIN.toString());
    var x = this.user.role?.includes(AdvisoryRoles.SERVICER_ADMIN.toString());
    return (x === undefined ? false : x) ? false : false; // for now always return false
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
